interface URLSearchParamMergeHandler {
  [key: string]: (filterString1: string, filterString2: string) => string;
}

const splitFilters = (filterString: string) =>
  filterString.split(';').map((keyValuesString) => keyValuesString.split(':'));

const handleMergeFilter = (filterString1: string, filterString2: string) => {
  const filters1 = splitFilters(filterString1);
  const filters2 = splitFilters(filterString2);

  return filters1
    .filter(([key1]) => !filters2.find(([key2]) => key1 === key2))
    .map((keyValues) => keyValues.join(':'))
    .concat(filters2.map((keyValues) => keyValues.join(':')))
    .join(';');
};

const urlSearchParamHandlers: URLSearchParamMergeHandler = {
  filter: handleMergeFilter,
};

const appendURLSearchParam = (urlSearchString: string, key: string, value: string) => {
  const urlSearchParams = new URLSearchParams(urlSearchString);
  const urlSearchParamValue = urlSearchParams.get(key);

  urlSearchParams.set(
    key,
    urlSearchParamHandlers[key] && urlSearchParamValue
      ? urlSearchParamHandlers[key](urlSearchParamValue, value)
      : value,
  );

  return urlSearchParams.toString();
};

const appendURLSearchParams = (
  urlSearchString: string,
  ...rest: [string, undefined | string][]
): string =>
  rest
    .filter((_) => _)
    .filter((pair): pair is [string, string] => !!(pair[0] && pair[1]))
    .reduce(
      (accURLSearchString, [key, value]) => appendURLSearchParam(accURLSearchString, key, value),
      urlSearchString,
    );

export default appendURLSearchParams;
